import * as mobx from 'mobx'
import { RootStore } from 'bzx-common/src/stores'
import WrapNativeFormVM from '../Lend/LendForm/WrapNativeFormVM'

interface IToolsVMProps {
  rootStore: RootStore
  wrapNativeForm: WrapNativeFormVM
}

export default class ToolsVM implements IToolsVMProps {
  rootStore: RootStore
  wrapNativeForm: WrapNativeFormVM

  set(prop: keyof IToolsVMProps, value: any) {
    ;(this[prop] as any) = value
  }

  assign(props: Partial<IToolsVMProps>) {
    Object.assign(this, props)
  }

  init() {
    setTimeout(() => {
      this.wrapNativeForm.init()
      this.wrapNativeForm.autoSync(true)
    }, 0)
  }

  destroyVM() {
    this.wrapNativeForm.destroyVM()
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, undefined, { deep: false, autoBind: true })
    this.wrapNativeForm = new WrapNativeFormVM(rootStore)
    this.init()
  }
}
